import { useEffect, useRef, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

const DEBOUNCE_MS = 600;

/** Server-rendered "as delivered" preview, refreshed (debounced) while enabled. */
export function useRecipientPreview(htmlContent, imageStrategy, previewUserId, enabled) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const requestId = useRef(0);

  useEffect(() => {
    const current = ++requestId.current;
    if (!enabled) {
      setLoading(false);
      return undefined;
    }
    setLoading(true);
    const timer = setTimeout(async () => {
      try {
        const { data: res } = await api.post("/signatures/recipient-preview", {
          html_content: htmlContent, image_strategy: imageStrategy,
          user_id: previewUserId || undefined,
        });
        if (current === requestId.current) setData(res);
      } catch (e) {
        if (current === requestId.current) toast.error(formatApiError(e, "No se pudo generar la vista del destinatario"));
      } finally {
        if (current === requestId.current) setLoading(false);
      }
    }, DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [htmlContent, imageStrategy, previewUserId, enabled]);

  return { data, loading };
}
